import { fetchWallpapersWide } from '../fetch/documents';
import { createReducer } from './createReducer';
const wallpapersWideSlice = createReducer("wallpapersWide", fetchWallpapersWide, false);


export const selectWallpapersWide = (state) => state.wallpapersWide.value
export const selectLoadingWallpapersWide = (state) => state.wallpapersWide.isLoading

export const {} = wallpapersWideSlice.actions

export default wallpapersWideSlice.reducer

